module.exports = __webpack_public_path__ + "img/about/80243-004.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-004.png
// module id = 14
// module chunks = 0